import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { type GridCellParams } from "@material-ui/x-grid";

import { type Theme } from "src/theme";

type Style = ((theme: Theme) => object) | object;

function makeRenderCell({
  valueFormatter,
  style,
}: {
  style?: Style;
  valueFormatter?: (params: GridCellParams) => any;
}) {
  const useStyles = makeStyles(
    style
      ? (theme) => ({
          root: typeof style === "function" ? style(theme as any) : style,
        })
      : { root: {} }
  );

  const Renderer = ({ params }: { params: GridCellParams }) => {
    const value = params.value;
    const classes = useStyles({ value });
    return (
      <span className={classes.root}>
        {valueFormatter ? valueFormatter(params) : params.value}
      </span>
    );
  };

  return (params: GridCellParams) => <Renderer params={params} />;
}

export default makeRenderCell;
